module.exports = new __parcel__URL__("artifact_0002.399f9f10.png").toString();